export default {
    smartSearch: {
        syntaxHelper: '検索ヘルプ >',
        sections: {
            ANCS: '[標準]現出願人(権利者)',
            AUTOCOMPLETE: '自動おすすめ',
            FIELD: '文法',
            HISTORY: '履歴',
            KEYWORDS: 'キーワード',
            LOGIC: '論理ワード',
            keywordFields: 'キーワードフィールド',
            assigneeFields: '権利者フィールド',
            classificationNumberFields: '分類フィールド',
            otherFields: 'その他のフィールド',
            SAMPLE: 'サンプル',
            CASE_NATURE: '案件の性質',
            TRIAL_GRADE: '訴訟審級',
            PLE_TYPE: '質権タイプ',
            PATENT_TYPE: '特許の種類',
            AUTHORITY: '発行国・機関',
            ANS_TYPE: '[標準]出願人(権利者)のタイプ',
            CASE_REGION: '案件場所',
            EXCLUSIVITY: 'ライセンスの排他性',
            SIMPLE_LEGAL_STATUS: '簡単リーガルステータス',
            LEGAL_STATUS: 'リーガルステータス',
            LEGAL_EVENT: 'リーガルイベント',
            CITE_CATEGORY: '引用タイプ',
            OUTCOME_STATUS: '案件の状況',
            ANCS_TYPE: '[標準]現出願人(権利者)のタイプ',
            GOV: '政府利益',
            LICENSE: 'ライセンスのタグ',
            LITIGATION: '訴訟のタグ',
            PLEDGE: '質権のタグ',
            REEXAMINVALID: '再審・無効審判のタグ',
            SEP_SOURCE: 'SEPソース',
            GNAME: 'カスタム権利者グループ',
            EPDS_LS: 'EP指定国/地域法的状況',
            EPDS_SLS: 'EP指定国/地域シンプル法的状況',
            ATC_VALUE: '事務所代理特許',
            UP_STATUS: 'UPCにおける法的状況',
            EFAM_STATUS: 'Patsnapファミリーのステータス',
        },
        keywordQueryTitle: '現在のカーソル位置の後に「{keyword}」の拡張語を追加します',
    },
};
